import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Login } from '../../components';
import { HomeScreen, ViewTransactions, UploadScreen, ReviewUpload, UploadMappings, StatsScreen } from '../../components/usr';

function App() {
    return (
        <div className="App">
            <div className="content">
                <Routes>
                    <Route path="/" element={<HomeScreen />} />
                    <Route path="/login" element={<Login />} />
                    <Route path='/transactions' element={<ViewTransactions />} />
                    <Route path='/upload' element={<UploadScreen />} />
                    <Route path='/reviewUpload' element={<ReviewUpload />} />
                    <Route path='/uploadMappings' element={<UploadMappings />} />
                    <Route path='/graph' element={<StatsScreen />} />
                </Routes>
            </div>
        </div>
    )
}

export default App;
